import { Button, Link } from '@tmov/design-system';
import { Modal, Row as RowAntd } from 'antd';
import styled from 'styled-components';

import colors from '../../../../styles/colors';

export const ModalContent = styled.div`
  margin-top: 32px;
`;
export const ModalInfo = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: ${props => (props.regular ? 400 : 600)};
  font-size: ${props => (props.regular ? '14px' : '16px')};
  line-height: 150%;
  color: ${props =>
    props.regular ? colors.$greyscale_dark_grey_10 : colors.$greyscale_black_5};
`;
export const ButtonCancel = styled(Link)`
  font-family: 'Inter' !important;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  padding: 8px 24px;
`;

export const ButtonPrimary = styled(Button)`
  font-family: 'Inter' !important;
  padding: 8px 24px;
  width: 105px;
  height: 36px;
`;

export const CustomModal = styled(Modal)`
  width: 464px !important;
  height: 426px !important;
  display: flex;
  flex-direction: column;

  .ant-modal-body {
    margin: 8px 4px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    border: none;
    margin-right: 20px;
    margin-bottom: 20px;
  }
`;

export const ModalTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;

  display: flex;
  flex-direction: row;
  align-items: center;

  color: ${colors.$brandcolor_primary_blue};
  margin-bottom: 32px;
`;
